export enum HostAccountStatus {
    None,
    Verified,
    PendingVerification,
}
